import styled from 'styled-components'

import ChevronDown from '../../../img/chevron-down.inline.svg'

export const Container = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: column;
  padding: 80px 2.25rem;
  background-color: ${({ theme }) => theme.colors.coolGray.cool150};

  @media (min-width: 768px) {
    flex-direction: row;
    padding-left: 4.5rem;
    padding-right: 4.5rem;
  }

  @media (min-width: 992px) {
    padding: 100px 5.5rem;
  }

  & > div {
    display: flex;
    flex-direction: column;
  }

  & > div:first-of-type {
    flex: 1;
  }

  & > div:last-of-type {
    flex: 3;
    gap: 16px;
  }
`

export const QuestionAndAnswerItem = styled.button`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 40px 34px;
  border-radius: 8px;
  border: none;
  background-color: ${({ theme }) => theme.colors.grayscale.white};
  cursor: pointer;
  transition: 0.3s ease-in-out;
`

export const QuestionContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`

export const Question = styled.h3`
  font-weight: 500;
  font-family: Gotham, sans-serif;
  text-align: left;
  font-size: 16px;
  margin: 0;
  color: ${({ theme }) => theme.colors.text.primary};

  @media (min-width: 768px) {
    font-size: 20px;
  }
`

export const AnswerContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 95%;
  padding: 24px 0 0 0;

  @media (min-width: 768px) {
    padding: 24px 0 0 12px;
  }
`

export const Answer = styled.p`
  font-size: 16px;
  margin: 0;
  text-align: left;
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const Icon = styled(ChevronDown)<{ $isOpen?: boolean }>`
  width: 40px;
  color: ${({ theme }) => theme.colors.text.primary};
  transform: rotate(${({ $isOpen }) => ($isOpen ? '180deg' : '0deg')});
`

export const Title = styled.h1`
  font-size: 32px;
  color: ${({ theme }) => theme.colors.text.primary};
  font-weight: 500;
  line-height: 1.3;
  text-align: center;

  @media (min-width: 768px) {
    font-size: 36px;
    text-align: left;
  }
`
